import { render, staticRenderFns } from "./customerDetail.vue?vue&type=template&id=46fcce69&scoped=true&"
import script from "./customerDetail.vue?vue&type=script&lang=js&"
export * from "./customerDetail.vue?vue&type=script&lang=js&"
import style0 from "./customerDetail.vue?vue&type=style&index=0&lang=css&"
import style1 from "./customerDetail.vue?vue&type=style&index=1&id=46fcce69&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46fcce69",
  null
  
)

export default component.exports